import dayjs from 'dayjs'
import de from 'dayjs/locale/de'
import en from 'dayjs/locale/en'
import fr from 'dayjs/locale/fr'
import it from 'dayjs/locale/it'
import pt_br from 'dayjs/locale/pt-br'
import uk from 'dayjs/locale/uk'
import zh_cn from 'dayjs/locale/zh-cn'
import updateLocale from 'dayjs/plugin/updateLocale'

export const setupDayjs = () => {
  dayjs.Ls.en.weekStart = 1
  dayjs.extend(updateLocale)
  dayjs.locale({
    ...en,
    ...pt_br,
    ...de,
    ...uk,
    ...it,
    ...fr,
    ...zh_cn
  })
}
